import {
  discoveryApiRef,
  fetchApiRef,
  SubPageBlueprint,
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { rbacApiRef, RbacApiClient } from './api';
import pages from './page';
import { createElement } from 'react';

const rbacApi = ApiBlueprint.make({
  name: 'rbacApi',
  params: defineParams =>
    defineParams({
      api: rbacApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RbacApiClient({ discoveryApi, fetchApi }),
    }),
});

const rbacAdminTab = SubPageBlueprint.make({
  attachTo: {
    id: 'page:devops-admin',
    input: 'pages',
  },
  name: 'rbacAdminTab',
  params: {
    path: 'rbac',
    title: 'RBAC',
    loader: () =>
      import('./components/RolePage').then(m =>
        createElement(m.AdminRbacPageTab),
      ),
  },
});

export const devopsRbacPlugin = createFrontendPlugin({
  pluginId: 'devops-rbac',
  routes: {
    root: rootRouteRef,
  },
  extensions: [rbacApi, ...pages, rbacAdminTab],
});
